export const matchClockLabel = (hours, spec) => spec?.version === 2 ? (spec.preset === '12h' ? 'Kişi başına 12 saat' : `Kişi başına ${spec.preset} dk`) : [12, 72].includes(Number(hours)) && hours != null ? `Tur başına ${Number(hours)} saat` : 'Süre bilgisi yok';
export const compactMatchClockLabel = (hours, spec) => spec?.version === 2
  ? spec.preset === '12h' ? '12 saat' : `${String(spec.preset).replace(/\+0$/, '')}+0`
  : matchClockLabel(hours, spec);
